(function () {
  'use strict';

  var PROMO_PROPERTY = '_iurop_promo_gift';
  var CAMPAIGN_ATTRIBUTE = 'iurop_threshold_gift_campaign__';
  var busy = false;
  var checkoutBusy = false;
  var checking = false;

  function campaign() { return document.querySelector('[data-threshold-gift-campaign]'); }
  function state() { return document.querySelector('[data-threshold-gift-state]'); }
  function selector() { return document.querySelector('[data-cart-gift]'); }
  function route(path) { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + path; }
  function promoGift(cart, key) {
    return cart && cart.items && cart.items.find(function (item) {
      return item.properties && item.properties[PROMO_PROPERTY] === key;
    });
  }
  function qualifyingSubtotal(cart, key) {
    return (cart && cart.items || []).reduce(function (sum, item) {
      if (item.properties && item.properties[PROMO_PROPERTY] === key) return sum;
      return sum + (typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price || 0);
    }, 0);
  }
  function request(path, body) {
    return fetch(route(path), {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('cart-request');
      return response.json();
    });
  }
  function fetchCart() { return request('cart.js'); }
  function syncCampaignAttribute(cart, addingGift) {
    var config = state();
    if (!config || !cart) return Promise.resolve(cart);
    var desired = config.dataset.enabled === 'true' && (addingGift || promoGift(cart, config.dataset.promoKey))
      ? config.dataset.promoKey : '';
    if ((cart.attributes && cart.attributes[CAMPAIGN_ATTRIBUTE] || '') === desired) return Promise.resolve(cart);
    var attributes = {};
    attributes[CAMPAIGN_ATTRIBUTE] = desired;
    return request('cart/update.js', { attributes: attributes });
  }
  function announceCart(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true, detail: { cart: cart, noOpen: true }
    }));
  }
  function setMessage(error) {
    var box = selector();
    var message = box && box.querySelector('[data-threshold-gift-message]');
    if (message) message.textContent = error ? campaign().dataset.error : '';
  }
  function setBusy(value) {
    busy = value;
    var box = selector();
    if (box) {
      box.setAttribute('aria-busy', String(value));
      var button = box.querySelector('[data-threshold-gift-add]');
      if (button) button.disabled = value || !box.querySelector('[data-threshold-gift-option]:checked:not(:disabled)');
    }
    document.querySelectorAll('[data-cart-drawer] [name="checkout"]').forEach(function (button) {
      button.disabled = value;
    });
  }
  function reconcile(cart) {
    var config = campaign();
    if (!config || busy) return Promise.resolve(cart);
    var gift = promoGift(cart, config.dataset.promoKey);
    var threshold = parseInt(config.dataset.thresholdCents, 10) || 12900;
    if (gift && qualifyingSubtotal(cart, config.dataset.promoKey) < threshold) {
      setBusy(true);
      return request('cart/change.js', { id: gift.key, quantity: 0 })
        .then(function (updated) { return syncCampaignAttribute(updated); })
        .then(function (updated) { announceCart(updated); return updated; })
        .finally(function () { setBusy(false); });
    }
    return syncCampaignAttribute(cart);
  }
  function refreshState() {
    if (checking || busy || checkoutBusy) return;
    checking = true;
    fetchCart().then(reconcile).catch(function () {}).finally(function () { checking = false; });
  }
  function addGift() {
    var config = campaign();
    var box = selector();
    var selected = box && box.querySelector('[data-threshold-gift-option]:checked:not(:disabled)');
    if (!config || !selected || busy || checkoutBusy) return;
    var variantId = Number(selected.value);
    var added = false;
    setBusy(true);
    setMessage(false);
    fetchCart().then(function (cart) {
      var threshold = parseInt(config.dataset.thresholdCents, 10) || 12900;
      if (promoGift(cart, config.dataset.promoKey) || qualifyingSubtotal(cart, config.dataset.promoKey) < threshold) {
        throw new Error('ineligible');
      }
      return syncCampaignAttribute(cart, true);
    }).then(function () {
      var properties = {};
      properties[PROMO_PROPERTY] = config.dataset.promoKey;
      properties._regalo = config.dataset.giftLabel;
      return request('cart/add.js', { items: [{ id: variantId, quantity: 1, properties: properties }] });
    }).then(function () {
      added = true;
      return fetchCart();
    }).then(function (cart) {
      var gift = promoGift(cart, config.dataset.promoKey);
      if (!gift || gift.final_line_price !== 0) throw new Error('gift-not-discounted');
      announceCart(cart);
    }).catch(function () {
      return fetchCart().then(function (cart) {
        var gift = promoGift(cart, config.dataset.promoKey);
        if (added && gift && gift.variant_id === variantId && gift.final_line_price !== 0) {
          return request('cart/change.js', { id: gift.key, quantity: 0 });
        }
        return cart;
      }).then(function (cart) { return syncCampaignAttribute(cart); })
        .catch(function () {})
        .finally(function () { setMessage(true); });
    }).finally(function () { setBusy(false); });
  }
  function checkout(event) {
    if (!campaign()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || checkoutBusy) return;
    checkoutBusy = true;
    fetchCart().then(reconcile).then(function () {
      window.location.assign(route('checkout'));
    }).catch(function () {
      window.location.assign(route('cart'));
    }).finally(function () { checkoutBusy = false; });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-cart-gift] [data-threshold-gift-option]')) return;
    setMessage(false);
    setBusy(busy);
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-gift] [data-threshold-gift-add]')) {
      event.preventDefault();
      addGift();
    }
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]')) checkout(event);
  }, true);
  document.addEventListener('submit', function (event) {
    if ((event.submitter && event.submitter.name === 'checkout') || /\/checkout(?:[/?#]|$)/.test(event.target.getAttribute('action') || '')) checkout(event);
  }, true);
  document.addEventListener('cart:updated', refreshState);
  document.addEventListener('cart:rendered', refreshState);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshState);
  else refreshState();

  function showSelector() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (drawer) {
      drawer.setAttribute('data-open', 'true');
      document.documentElement.setAttribute('data-drawer-open', 'true');
    }
    var box = selector();
    if (box) box.scrollIntoView({ block: 'nearest' });
  }
  window.iuropThresholdGift = {
    showNotice: showSelector,
    showReward: showSelector,
    close: function () {},
    reset: refreshState,
    qualifyingSubtotal: qualifyingSubtotal
  };
})();
